import cookie from 'vue-cookies';
import { USER_TYPE } from '@/utils/const';

export const CACHE_KEYS = {
  CLIENT: 'client',
  POLICIES: 'policies',
  QUOTES: 'quotes',
  NOTIFICATIONS: 'notifications',
  AGENT_DASHBOARD: 'dashboard',
};

export function resolvePortalChannel(explicit) {
  if (explicit === 'agent' || explicit === 'customer') return explicit;
  return cookie.get(USER_TYPE) === 'agent' ? 'agent' : 'customer';
}

export function isAgentPortal() {
  return resolvePortalChannel() === 'agent';
}

export function bootstrapPortalCache(store, { channel, force = false } = {}) {
  if (!store.getters['auth/isAuthenticated']) return Promise.resolve();
  return store.dispatch('portalCache/bootstrap', {
    channel: resolvePortalChannel(channel),
    force,
  });
}

export function invalidatePortalCache(store, keys, { channel, refresh = true } = {}) {
  return store.dispatch('portalCache/invalidate', {
    channel: resolvePortalChannel(channel),
    keys,
    refresh,
    force: true,
  });
}

/** After payment or policy issuance — quotes and policies are stale. */
export function invalidateAfterPayment(store, channel) {
  const resolved = resolvePortalChannel(channel);
  if (resolved === 'agent') {
    return invalidatePortalCache(store, [CACHE_KEYS.AGENT_DASHBOARD], { channel: 'agent' });
  }
  return invalidatePortalCache(store, [CACHE_KEYS.QUOTES, CACHE_KEYS.POLICIES, CACHE_KEYS.NOTIFICATIONS], {
    channel: 'customer',
  });
}

/** After saving or updating a quote mid-flow. */
export function invalidateAfterQuoteSave(store, channel) {
  const resolved = resolvePortalChannel(channel);
  if (resolved === 'agent') {
    return invalidatePortalCache(store, [CACHE_KEYS.AGENT_DASHBOARD], { channel: 'agent' });
  }
  return invalidatePortalCache(store, [CACHE_KEYS.QUOTES], { channel: 'customer' });
}

export function clearPortalCache(store) {
  return store.dispatch('portalCache/clearAll');
}

let portalCacheInvalidationSetup = false;
let portalCachePaymentListenersSetup = false;

export function setupPortalCacheInvalidation(store, router) {
  if (portalCacheInvalidationSetup) return;
  portalCacheInvalidationSetup = true;

  const saleRoutePattern = /\/(agent\/)?(sale|pa|travel|buy|cover|payment|finalization)/i;

  router.afterEach((to, from) => {
    if (!store.getters['auth/isAuthenticated']) return;
    if (!from.name || from.name === to.name) return;

    const leftSaleFlow = saleRoutePattern.test(from.path) && !saleRoutePattern.test(to.path);
    if (!leftSaleFlow) return;

    const channel = resolvePortalChannel();
    if (channel === 'agent') {
      invalidatePortalCache(store, [CACHE_KEYS.AGENT_DASHBOARD], { channel: 'agent' });
    } else {
      invalidatePortalCache(store, [CACHE_KEYS.QUOTES, CACHE_KEYS.POLICIES], { channel: 'customer' });
    }
  });
}

export function setupPortalCachePaymentListeners(store, root) {
  if (portalCachePaymentListenersSetup) return;
  portalCachePaymentListenersSetup = true;

  root.$on('successful-payment', () => {
    invalidateAfterPayment(store);
  });
}
